import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ErrorBoundary, ScrollToTop } from './components';
import { useHistory } from 'react-router-dom';
import './App.css'; // Import global styles
import { Loading } from './components/Loading';
import IdleTimer from './components/elements/utils/idleTimer';
import { GlobalDebug } from './utils/disableConsoleLog';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { closeSubscriptionModal } from './app/services/subscriptionModalSlice';
import DisplaySubscriptionModal from './components/DisplaySubscriptionModal';
import { closeUpgradeSubscriptionModal } from './app/services/upgradeSubModalSlice';
import DisplayCreateSubscriptionModal from './components/DisplayCreateSubscriptionModal';
const Hospital = lazy(() => import('./pages/HospitalAdmin'));
const Patient = lazy(() => import('./pages/PatientDashboard'));
const SuperAdmin = lazy(() => import('./pages/SuperAdmin'));
const Sample = lazy(() => import('./pages/sample'));
//this is mayowa debby push

function SubscriptionModal() {
	const open = useSelector((state: any) => state.subscriptionModal.open);
	const dispatch = useDispatch();
	console.log('SubscriptionModal open:', open);
	 const handleClose = () => {
        dispatch(closeSubscriptionModal());
    };

	return (
		<Modal show={open} centered >
		< DisplayCreateSubscriptionModal handleClose={handleClose}/>	
		</Modal>
	);
}
function UpgradeSubscriptionModal() {
	const open = useSelector((state: any) => state.upgradeSubscriptionModal.open);
	const dispatch = useDispatch();
	console.log('UpgradeSubscriptionModal open:', open);
	 const handleClose = () => {
        dispatch(closeUpgradeSubscriptionModal());
    };

	return (
		<Modal show={open} centered 
		>
			< DisplaySubscriptionModal handleClose={handleClose}/>
		</Modal>
	);
}

function App() {
	useEffect(() => {
		(process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENV === 'STAGING') && GlobalDebug(false, true);
	}, []);
	return (
		<ErrorBoundary>
			<Suspense fallback={<Loading />}>
				<Router>
					<ScrollToTop />
					<Switch>
						<Route path="*" component={Hospital} />

						{/* <Route exact path="/hospital" component={Hospital} /> */}
						{/* <Route path="/patient" component={Patient} />
	<Route path="/admin" component={SuperAdmin} /> */}
						{/* <Route exact path="/hospital" component={Hospital} /> */}
					</Switch>
					<SubscriptionModal />
					<UpgradeSubscriptionModal />
				</Router>
			</Suspense>
		</ErrorBoundary>
	);
}

export default App;
